(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      /* Houseplant: do nothing while the mobile menu is open.

         The drawer pins the header on open (HeaderDrawer.openMenuDrawer)
         because its panel is positioned below it. Every branch under here can
         move the header: hide() translates it fully out of view and reset()
         removes the pin, so one scroll event landing mid-menu takes the bar,
         and the close X with it, off the screen while the panel stays put.
         Momentum scrolling makes that easy to hit on a phone even with the
         page locked.

         ASCII ONLY IN THIS BLOCK. A single non-ASCII character anywhere in a
         {% javascript %} block breaks the WHOLE bundle: an em dash in this very
         comment left sticky-header, header-wrapper and header-menu-toggle all
         undefined, with nothing in the console. See CLAUDE.md. */
      if (document.body.classList.contains('menu-mobile--open') ||
          document.body.classList.contains('menu-mobile--opening')) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        /* Houseplant: a FULL reset at the top, not just the sticky class.

           Base removed 'shopify-section-header-sticky' here and left
           'shopify-section-header-hidden' and 'animate' behind. Two consequences,
           both real:

           1. 'animate' surviving is what produced the flash at scrollY 64-80.
              Scrolling down from the top, hide() adds 'sticky' and 'hidden'
              together; 'sticky' pins the header back into view at top 0 while
              'hidden' translates it away, and with a transform transition still
              armed the browser animates between the two - so the bar visibly
              slides in and straight back out. Clearing 'animate' here means the
              first hide after a return to the top snaps, which is what it is
              meant to do.
           2. 'hidden' surviving is a latent bug of its own: scroll past 64, then
              back to 0 without ever crossing 64 upwards (so reveal never fires),
              and the header sits at the top of the page translated up by its own
              height - present, laid out, and invisible.

           reset() already removes exactly these three, so call it rather than
           restating the list. */
        this.reset();
        document.body.classList.remove('shopify-body-section-header-sticky', 'shopify-body-section-header-hidden');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      /* Houseplant: the SETTING decides on both breakpoints.

         This test used to read `theme.config.mqlSmall || this.scrollUpActive`,
         so mobile ALWAYS took the reveal-on-scroll-up branch no matter what
         "Show sticky header on scroll up" was set to. That is why the header
         could be switched to always-sticky and still hide on the way down on a
         phone - the setting was reachable in the editor and had no effect
         below the small breakpoint.

         Dropping the mqlSmall force does not remove the behaviour, it just
         makes the checkbox mean the same thing everywhere: on = hide going
         down and reveal coming up, off = pinned the whole time. Nothing in
         component-sticky-header.css gates stickiness by width, so the pinned
         mode works at every size already.

         ASCII ONLY IN THIS BLOCK - see the note further up: one non-ASCII
         character anywhere in this {% javascript %} tag kills the whole bundle
         silently, taking sticky-header, header-wrapper and header-menu-toggle
         with it. */
      if (this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        /* Houseplant: NO HIDE-THEN-REVEAL. Base pinned the header by hiding it
           and revealing it 300ms later, so the bar dropped in from above the
           first time you scrolled past it - reported as "it pops down from the
           top instead of staying visible", and it is the wrong idiom: an
           entrance animation for something that is supposed to have been there
           all along.

           There is nothing to animate now because the header never leaves. It
           is `position: sticky` from the start in custom.css, so this branch
           only adds the class that draws the pinned drop shadow. Measured
           before changing it: the sticky class shifts NOTHING - 80 tall on
           desktop and 64 on mobile in both states, and the logo, menu and icon
           row all sit at an identical y. So applying it mid-scroll cannot move
           anything, which is what makes the animation unnecessary rather than
           merely unwanted. */
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;

          requestAnimationFrame(this.reveal.bind(this));
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      /* Houseplant: never animate a header that is not already pinned.

         'sticky' and 'hidden' arrive together on the first hide, and they say
         opposite things: sticky pins the bar at the top of the viewport, hidden
         translates it out. Applied in one recalc that is invisible, which is the
         intent. Applied with a transform transition armed, the browser has to
         animate from one to the other, so the bar flashes into view and slides
         away again.

         A header that IS already pinned is genuinely on screen and should
         animate out - that is the normal hide-on-scroll-down. So the transition
         is dropped only for the un-pinned case. */
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.remove('animate');
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
